// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-widget-composebar {
  display: inline-block;
  width: 100%;
  background: var(--chat-widget-footer-bg);
  border-top: 1px solid var(--chat-widget-compose-bar-border);
  position: relative;
}
.chat-widget-composebar .attachment-wrapper-data .drag-drop-upload {
  margin-bottom: 0;
}
.chat-widget-composebar .drag-file-pointer {
  display: none;
}
.chat-widget-composebar.is-dragging .attachment-upload-card {
  border-color: var(--sdk-global-theme-color) !important;
}
.chat-widget-composebar.is-dragging .drag-file-pointer {
  display: block;
}
.chat-widget-composebar .voice-speak-msg-info {
  text-align: right;
  padding: 10px 16px 0px 16px;
  display: block;
  position: relative;
  margin-bottom: 40px;
}
.chat-widget-composebar .voice-speak-msg-info .remove-voice-text {
  position: absolute;
  top: 4px;
  right: 8px;
  width: 16px;
  height: 16px;
  background: var(--sdk-global-white-bg);
  border: 1px solid var(--sdk-gloabl-border-color);
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  padding: 0;
  z-index: 1;
}
.chat-widget-composebar .voice-speak-msg-info .remove-voice-text svg path {
  fill: var(--chat-widget-compose-bar-text-area-color);
}
.chat-widget-composebar .voice-speak-msg-info .voice-msg-bubble {
  display: inline-block;
  border: 1px solid var(--chat-widget-compose-bar-voice-speak-msg-border);
  border-radius: 12px 4px 12px 12px;
  max-width: 90%;
  text-align: start;
  padding: 7px 12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--chat-widget-compose-bar-voice-speak-msg-color);
  background: var(--chat-widget-compose-bar-voice-speak-msg-bg);
}
.chat-widget-composebar .voice-speak-msg-info .voice-msg-bubble.speak-done-bg {
  background: var(--chat-widget-compose-bar-voice-speak-msg-selected-bg);
}
.chat-widget-composebar .compose-bar-wrapper {
  background: var(--chat-widget-compose-bar-bg);
  border-radius: 0px 0px 4px 4px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
  animation-name: right-to-left-slide-anim;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose {
  align-items: center;
  padding: 13px 16px;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-text-area {
  display: none;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording {
  width: 100%;
  text-align: center;
  position: relative;
  display: block;
  animation-name: voiceShowAnim;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text .voice-compose-btn, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end .voice-compose-btn, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end .voice-compose-btn-end, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .voice-compose-btn, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .voice-compose-btn-recording {
  width: 50px;
  height: 50px;
  background: var(--chat-widget-compose-bar-voice-icon-bg);
  border: 2px solid var(--chat-widget-compose-bar-voice-icon-border);
  color: var(--chat-widget-compose-bar-voice-icon-color);
  border-radius: 62px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: absolute;
  top: -42px;
  right: 0;
  left: 0;
  cursor: pointer;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text .voice-compose-btn svg path, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end .voice-compose-btn svg path, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end .voice-compose-btn-end svg path, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .voice-compose-btn svg path, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .voice-compose-btn-recording svg path {
  fill: var(--sdk-global-white);
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text .voice-compose-btn svg rect, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end .voice-compose-btn svg rect, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end .voice-compose-btn-end svg rect, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .voice-compose-btn svg rect, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .voice-compose-btn-recording svg rect {
  fill: var(--sdk-global-white);
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text .speak-info, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end .speak-info, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .speak-info {
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: var(--chat-widget-compose-bar-voice-speak-info-text);
  margin-top: 10px;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording {
  opacity: 1 !important;
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn !important;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .voice-compose-btn-recording {
  animation: recording 2s infinite ease-in-out;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .voice-compose-btn-recording .speak-info {
  margin-top: 15px;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording .cancel-sepak {
  background: transparent;
  border: 0;
  padding: 2px 8px;
  color: var(--sdk-global-theme-color);
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  margin-top: 4px;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end {
  animation-name: bubbleAnim;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
  opacity: 1 !important;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .action-btn {
  margin-top: 0;
}
.chat-widget-composebar .compose-bar-wrapper.if-voice-compose .voice-btn {
  margin-top: 0;
}
.chat-widget-composebar .compose-bar-wrapper .action-btn {
  width: 20px;
  height: 20px;
  border: 0;
  padding: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  margin-right: 8px;
  flex-shrink: 0;
  color: var(--chat-widget-compose-bar-text-area-color);
}
.chat-widget-composebar .compose-bar-wrapper .action-btn.hamberger-menu svg path {
  fill: var(--chat-widget-compose-bar-menu-icon-color);
}
.chat-widget-composebar .compose-bar-wrapper .action-btn.connect-to-agent svg path {
  stroke: var(--chat-widget-compose-bar-other-icons);
  fill: none;
}
.chat-widget-composebar .compose-bar-wrapper .action-btn.connect-to-agent.disabled {
  opacity: 0.4;
  cursor: none;
  pointer-events: none;
}
.chat-widget-composebar .compose-bar-wrapper .action-btn svg path {
  fill: var(--chat-widget-compose-bar-other-icons);
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area {
  position: relative;
  width: 100%;
  border-radius: 4px;
  line-height: 1px;
  transform-origin: right bottom;
  transition: 0.2s all ease-in-out;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area.emoji-btn-true .typing-text-area {
  padding-right: 62px;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area.only-emoji-btn .emoji-btn {
  right: 12px;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .emoji-btn {
  width: 20px;
  height: 20px;
  border: 0;
  padding: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 38px;
  top: 12px;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .emoji-btn figure {
  line-height: 0;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .emoji-btn svg path {
  fill: var(--sdk-gloabl-text-color);
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .speaker-btn {
  width: 20px;
  height: 20px;
  border: 0;
  padding: 0;
  background: transparent;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 12px;
  top: 12px;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .speaker-btn-speak svg path {
  fill: none;
  stroke: var(--chat-widget-compose-bar-other-icons);
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .speaker-btn-speak.show {
  display: flex;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .speaker-btn-speak.hide {
  display: none;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .speaker-btn-mute svg path {
  fill: var(--chat-widget-compose-bar-other-icons);
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .speaker-btn-mute.show {
  display: flex;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .speaker-btn-mute.hide {
  display: none;
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .typing-text-area {
  width: 100%;
  padding: 12px 35px 12px 12px;
  resize: none;
  background: var(--chat-widget-compose-bar-text-area-bg);
  border: 1px solid var(--chat-widget-compose-bar-text-area-border);
  border-radius: 4px;
  height: 44px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--chat-widget-compose-bar-text-area-color);
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .typing-text-area::placeholder {
  color: var(--chat-widget-compose-bar-text-area-placeholder-color);
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .typing-text-area:focus {
  border: 0.5px solid var(--sdk-global-theme-color);
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .typing-text-area:active {
  border: 0.5px solid var(--sdk-global-theme-color);
}
.chat-widget-composebar .compose-bar-wrapper .compose-text-area .typing-text-area:focus-visible {
  outline-color: var(--sdk-global-theme-color);
  outline-offset: 0px;
  outline-style: solid;
}
.chat-widget-composebar .compose-bar-wrapper .compose-voice-text, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-recording, .chat-widget-composebar .compose-bar-wrapper.if-voice-compose .compose-voice-text-end {
  display: none;
}
.chat-widget-composebar .compose-bar-wrapper .compose-voice-text-recording {
  display: none;
}
.chat-widget-composebar .compose-bar-wrapper .compose-voice-text-end {
  display: none;
}
.chat-widget-composebar .compose-bar-wrapper .key-board {
  width: 20px;
  height: 20px;
  border: 0;
  padding: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  margin-left: 8px;
  flex-shrink: 0;
}
.chat-widget-composebar .compose-bar-wrapper .key-board svg path {
  fill: var(--chat-widget-compose-bar-other-icons);
}
.chat-widget-composebar .compose-bar-wrapper .voice-btn {
  width: 20px;
  height: 20px;
  border: 0;
  padding: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  margin-left: 8px;
  flex-shrink: 0;
}
.chat-widget-composebar .compose-bar-wrapper .voice-btn svg path {
  fill: var(--chat-widget-compose-bar-other-icons);
}
.chat-widget-composebar .compose-bar-wrapper .send-btn {
  width: 41px;
  height: 44px;
  background: var(--sdk-global-theme-color);
  border-radius: 4px;
  padding: 0;
  border: 0;
  display: none;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  cursor: pointer;
  margin-left: 8px;
}
.chat-widget-composebar .compose-bar-wrapper .send-btn svg path {
  fill: var(--sdk-global-white);
}
.chat-widget-composebar .compose-bar-wrapper .send-btn.show {
  display: flex;
}
.chat-widget-composebar .compose-bar-wrapper .send-btn.disabled {
  background-color: #CDD5DF;
  cursor: none;
  pointer-events: none;
}
.chat-widget-composebar .emoji-picker-section {
  height: 280px;
  position: absolute;
  top: -262px;
  z-index: 1;
  width: 360px;
  right: 20px;
  border-radius: 16px;
  background: var(--sdk-global-white-bg);
  box-shadow: 0px 32px 64px -12px rgba(16, 24, 40, 0.14);
}
.chat-widget-composebar .emoji-picker-section::before {
  content: "";
  position: absolute;
  bottom: -8px;
  right: 64px;
  width: 16px;
  height: 16px;
  background: #fff;
  transform: rotate(45deg);
  background: var(--sdk-global-white-bg);
  filter: drop-shadow(0px 24px 48px rgba(16, 24, 40, 0.18));
}
.chat-widget-composebar .emoji-picker-section.emoji-only::before {
  right: 38px;
}
.chat-widget-composebar .emoji-picker-section emoji-picker {
  height: 100%;
  width: 100%;
  padding: 10px;
}

.disableComposeBar {
  pointer-events: none;
  opacity: 0.4;
}

.attachment-wrapper-data {
  border-radius: 0px 0px 4px 4px;
}
.attachment-wrapper-data .select-file-block .inputfile-btn {
  flex: 0 0 calc((100% - 12px) / 2);
  width: calc((100% - 12px) / 2);
  min-width: 0;
  border: 1px solid var(--sdk-global-white-bg);
  padding: 12px 20px;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: var(--button-text-color);
  height: 44.72px;
  gap: 8px;
}
.attachment-wrapper-data .select-file-block .inputfile-btn svg path {
  fill: var(--button-text-color);
}
.attachment-wrapper-data .select-file-block .inputfile-btn input {
  position: absolute;
  opacity: 0;
  left: 0;
  width: 100%;
  height: 100%;
  top: 0px;
  font-size: 0px;
  cursor: pointer;
}
.attachment-wrapper-data.hide-attachment {
  display: none;
}

.uploaded-attachment-data {
  background: var(--sdk-global-white-bg);
  border-radius: 4px;
  display: inline-block;
  width: 100%;
  overflow-y: auto;
  max-height: 250px;
}
.uploaded-attachment-data:not(:empty) {
  padding: 8px 16px;
}
.uploaded-attachment-data .uploaded-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  width: 100%;
  word-break: break-word;
}
.uploaded-attachment-data .uploaded-item .img-block {
  width: 56px;
  height: 56px;
  background: var(--sdk-gloabl-bg-secondary);
  border-radius: 4px;
  flex-shrink: 0;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.uploaded-attachment-data .uploaded-item .content-data {
  width: 100%;
}
.uploaded-attachment-data .uploaded-item .content-data h1 {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--sdk-gloabl-text-color);
  margin-bottom: 8px;
}
.uploaded-attachment-data .uploaded-item .content-data .progress-percentage {
  height: 5px;
  width: 100%;
  background: var(--sdk-gloabl-bg-secondary);
  border-radius: 4px;
  margin: 8px 0;
}
.uploaded-attachment-data .uploaded-item .content-data .progress-percentage div {
  height: 100%;
  background: var(--sdk-global-theme-color);
  border-radius: 4px;
  width: 70%;
}
.uploaded-attachment-data .uploaded-item .content-data .size-completion {
  display: flex;
}
.uploaded-attachment-data .uploaded-item .content-data .size-completion .file-size {
  padding-right: 3px;
}
.uploaded-attachment-data .uploaded-item .content-data .size-completion p {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: var(--sdk-gloabl-text-color);
}
.uploaded-attachment-data .uploaded-item .content-data .upload-error-status {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}
.uploaded-attachment-data .uploaded-item .content-data .upload-error-status.hide-error-status {
  display: none;
}
.uploaded-attachment-data .uploaded-item .content-data .upload-error-status .upload-failed-text {
  font-size: 12px;
  line-height: 18px;
  color: #D92D20;
  font-weight: 500;
}
.uploaded-attachment-data .uploaded-item .content-data .upload-error-status .info-icon {
  display: flex;
  align-items: center;
  cursor: help;
  position: relative;
}
.uploaded-attachment-data .uploaded-item .content-data .upload-error-status .info-icon .error-tooltip {
  visibility: hidden;
  width: max-content;
  max-width: 250px;
  background-color: var(--sdk-global-white-bg);
  color: var(--sdk-gloabl-text-color);
  border-radius: 6px;
  padding: 8px 12px;
  position: absolute;
  z-index: 9;
  bottom: 150%;
  left: -8px;
  box-shadow: var(--form-temp-input-box-shadow);
  border: 1px solid var(--sdk-gloabl-border-color);
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  white-space: normal;
  word-wrap: break-word;
  opacity: 0;
  transition: opacity 0.2s;
}
.uploaded-attachment-data .uploaded-item .content-data .upload-error-status .info-icon .error-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 14px;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: var(--sdk-global-white-bg) transparent transparent transparent;
}
.uploaded-attachment-data .uploaded-item .content-data .upload-error-status .info-icon:hover .error-tooltip {
  visibility: visible;
  opacity: 1;
}
.uploaded-attachment-data .uploaded-item .delete-upload {
  cursor: pointer;
  line-height: normal;
  margin-left: 8px;
  padding: 0;
  border: 0;
  background: transparent;
}
.uploaded-attachment-data .uploaded-item .delete-upload figure {
  line-height: 0;
}
.uploaded-attachment-data .uploaded-item.upload-success .progress-percentage {
  display: none;
}
.uploaded-attachment-data .uploaded-item.upload-success .size-completion .file-size {
  display: none;
}
.uploaded-attachment-data .uploaded-item.upload-success .size-completion p {
  color: #008000;
  font-weight: 500;
}

.typing-indicator-wraper {
  position: absolute;
  top: -28px;
  left: 0;
  width: auto;
  min-width: 116px;
  display: none;
  align-items: center;
  gap: 20px;
  padding: 4px 0 4px 16px;
  border-radius: 0px 6px 6px 0px;
  background: var(--sdk-global-white-bg);
  z-index: 9;
}
.typing-indicator-wraper p {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin-right: 6px;
}
.typing-indicator-wraper .dot-flashing {
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: var(--sdk-global-theme-color);
  color: var(--sdk-global-theme-color);
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.typing-indicator-wraper .dot-flashing::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: -15px;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: var(--sdk-global-theme-color);
  color: var(--sdk-global-theme-color);
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}
.typing-indicator-wraper .dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  left: 15px;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: var(--sdk-global-theme-color);
  color: var(--sdk-global-theme-color);
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}

.powerdby-info {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  background: var(--sdk-global-white-bg);
  height: 18px;
}
.powerdby-info p {
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: var(--welecome-footer-text-color);
  margin-right: 5px;
  flex-shrink: 0;
}
.powerdby-info figure {
  padding: 0 0 3px 0;
}
.powerdby-info.powerdby-hide {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/chatWidgetComposeBar/chatWidgetComposeBar.scss"],"names":[],"mappings":"AAEA;EACI,qBAAA;EACA,WAAA;EACA,wCAAA;EACA,2DAAA;EAEA,kBAAA;AAFJ;AAGI;EACI,gBAAA;AADR;AAII;EACI,aAAA;AAFR;AAMQ;EACI,sDAAA;AAJZ;AAMQ;EACI,cAAA;AAJZ;AAOI;EACI,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AALR;AAMQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,gDAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AAJZ;AAMgB;EACI,oDAAA;AAJpB;AAQQ;EACI,qBAAA;EACA,uEAAA;EACA,iCAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2DAAA;EACA,6DAAA;AANZ;AAOY;EACI,sEAAA;AALhB;AASI;EACI,6CAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,wCAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AAPR;AAQQ;EACI,mBAAA;EACA,kBAAA;AANZ;AAOY;EACI,aAAA;AALhB;AAOY;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AALhB;AAMgB;EACI,WAAA;EACA,YAAA;EACA,wDAAA;EACA,kEAAA;EACA,sDAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;AAJpB;AAMwB;EACI,6BAAA;AAJ5B;AAMwB;EACI,6BAAA;AAJ5B;AAQgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2DAAA;EACA,gBAAA;AANpB;AASY;EAEI,qBAAA;EACA,8BAAA;EACA,iCAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AARhB;AASgB;EAEI,4CAAA;AARpB;AASoB;EACI,gBAAA;AAPxB;AAUgB;EACI,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AARpB;AAWY;EAEI,0BAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;EACA,qBAAA;AAVhB;AAeY;EACI,aAAA;AAbhB;AAeY;EACI,aAAA;AAbhB;AAgBQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qDAAA;AAdZ;AAiBoB;EACI,oDAAA;AAfxB;AAqBoB;EACI,kDAAA;EACA,UAAA;AAnBxB;AAsBgB;EACI,YAAA;EACA,YAAA;EACA,oBAAA;AApBpB;AAwBgB;EACI,gDAAA;AAtBpB;AA0BQ;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,gCAAA;AAxBZ;AA0BgB;EACI,mBAAA;AAxBpB;AA4BgB;EACI,WAAA;AA1BpB;AA6BY;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA3BhB;AA4BgB;EACI,cAAA;AA1BpB;AA6BoB;EACI,kCAAA;AA3BxB;AA+BY;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA7BhB;AAiCoB;EACI,UAAA;EACA,kDAAA;AA/BxB;AAkCgB;EACI,aAAA;AAhCpB;AAkCgB;EACI,aAAA;AAhCpB;AAqCoB;EACI,gDAAA;AAnCxB;AAsCgB;EACI,aAAA;AApCpB;AAsCgB;EACI,aAAA;AApCpB;AAuCY;EACI,WAAA;EACA,4BAAA;EACA,YAAA;EACA,uDAAA;EACA,iEAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qDAAA;AArChB;AAuCgB;EACI,iEAAA;AArCpB;AAuCgB;EACI,iDAAA;AArCpB;AAuCgB;EACI,iDAAA;AArCpB;AAuCgB;EACI,4CAAA;EACA,mBAAA;EACA,oBAAA;AArCpB;AAyCQ;EACI,aAAA;AAvCZ;AAyCQ;EACI,aAAA;AAvCZ;AAyCQ;EACI,aAAA;AAvCZ;AAyCQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAvCZ;AAyCgB;EACI,gDAAA;AAvCpB;AA2CQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAzCZ;AA2CgB;EACI,gDAAA;AAzCpB;AA6CQ;EACI,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AA3CZ;AA6CgB;EACI,6BAAA;AA3CpB;AA8CY;EACI,aAAA;AA5ChB;AA8CY;EACI,yBAAA;EACA,YAAA;EACA,oBAAA;AA5ChB;AAgDI;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,sCAAA;EACA,sDAAA;AA9CR;AA+CQ;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EAIA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,sCAAA;EACA,yDAAA;AAhDZ;AAkDQ;EACI,WAAA;AAhDZ;AAkDQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;AAhDZ;;AAqDA;EACI,oBAAA;EACA,YAAA;AAlDJ;;AAwDA;EACI,8BAAA;AArDJ;AAuDQ;EACI,iCAAA;EACA,8BAAA;EACA,YAAA;EACA,4CAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,QAAA;AArDZ;AAuDgB;EACI,8BAAA;AArDpB;AAwDY;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAtDhB;AA0DI;EACI,aAAA;AAxDR;;AA6DA;EACI,sCAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AA1DJ;AA2DI;EACI,iBAAA;AAzDR;AA2DI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;AAzDR;AA0DQ;EACI,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxDZ;AA0DQ;EACI,WAAA;AAxDZ;AAyDY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,kBAAA;AAvDhB;AAyDY;EACI,WAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;AAvDhB;AAwDgB;EACI,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;AAtDpB;AAyDY;EACI,aAAA;AAvDhB;AAwDgB;EACI,kBAAA;AAtDpB;AAwDgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;AAtDpB;AAyDY;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAvDhB;AAwDgB;EACI,aAAA;AAtDpB;AAyDgB;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAvDpB;AAyDgB;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAvDpB;AAwDoB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,mCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,6CAAA;EACA,gDAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,UAAA;EACA,wBAAA;AAvDxB;AAyDwB;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4EAAA;AAvD5B;AA2DoB;EACI,mBAAA;EACA,UAAA;AAzDxB;AA8DQ;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;AA5DZ;AA6DY;EACI,cAAA;AA3DhB;AA+DY;EACI,aAAA;AA7DhB;AAgEgB;EACI,aAAA;AA9DpB;AAgEgB;EACI,cAAA;EACA,gBAAA;AA9DpB;;AAyEA;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,8BAAA;EACA,sCAAA;EACA,UAAA;AAtEJ;AAuEI;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AArER;AAuEI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,+CAAA;EACA,oCAAA;EACA,oDAAA;EACA,qBAAA;AArER;AAsEQ;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,+CAAA;EACA,oCAAA;EACA,6CAAA;EACA,mBAAA;AApEZ;AAsEQ;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,+CAAA;EACA,oCAAA;EACA,6CAAA;EACA,mBAAA;AApEZ;;AA0EA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sCAAA;EACA,YAAA;AAvEJ;AAwEI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wCAAA;EACA,iBAAA;EACA,cAAA;AAtER;AAwEI;EACI,kBAAA;AAtER;AAwEI;EACI,aAAA;AAtER","sourcesContent":["\n\n.chat-widget-composebar{\n    display: inline-block;\n    width: 100%;\n    background: var(--chat-widget-footer-bg);\n    border-top: 1px solid var(--chat-widget-compose-bar-border);\n    // border-radius: 0px 0px 4px 4px;\n    position: relative;\n    .attachment-wrapper-data .drag-drop-upload {\n        margin-bottom: 0;\n    }\n\n    .drag-file-pointer {\n        display: none;\n    }\n\n    &.is-dragging {\n        .attachment-upload-card {\n            border-color: var(--sdk-global-theme-color) !important;\n        }\n        .drag-file-pointer {\n            display: block;\n        }\n    }\n    .voice-speak-msg-info{\n        text-align: right;\n        padding: 10px 16px 0px 16px;\n        display: block;\n        position: relative;\n        margin-bottom: 40px;\n        .remove-voice-text{\n            position: absolute;\n            top: 4px;\n            right: 8px;\n            width: 16px;\n            height: 16px;\n            background: var(--sdk-global-white-bg);\n            border: 1px solid var(--sdk-gloabl-border-color);\n            border-radius: 32px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            font-size: 10px;\n            padding: 0;\n            z-index: 1;\n            svg{\n                path{\n                    fill: var(--chat-widget-compose-bar-text-area-color);   \n                }\n            }\n        }\n        .voice-msg-bubble{\n            display: inline-block;\n            border: 1px solid var(--chat-widget-compose-bar-voice-speak-msg-border);\n            border-radius: 12px 4px 12px 12px;\n            max-width: 90%;\n            text-align: start;\n            padding: 7px 12px;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 17px;\n            color: var(--chat-widget-compose-bar-voice-speak-msg-color);\n            background: var(--chat-widget-compose-bar-voice-speak-msg-bg);\n            &.speak-done-bg{\n                background: var(--chat-widget-compose-bar-voice-speak-msg-selected-bg);\n            }\n        }\n    }\n    .compose-bar-wrapper{\n        background: var(--chat-widget-compose-bar-bg);        \n        border-radius: 0px 0px 4px 4px;\n        padding: 16px;\n        display: flex;\n        align-items: flex-start;\n        animation-name: right-to-left-slide-anim;\n        animation-duration: 0.2s;\n        animation-fill-mode: forwards;\n        opacity: 0;\n        &.if-voice-compose{\n            align-items: center;\n            padding: 13px 16px;\n            .compose-text-area{\n                display: none;\n            }\n            .compose-voice-text{\n                width: 100%;\n                text-align: center;\n                position: relative;\n                display: block;\n                animation-name: voiceShowAnim;\n                animation-duration: 0.5s;\n                animation-fill-mode: forwards;\n                opacity: 0;\n                .voice-compose-btn{\n                    width: 50px;\n                    height: 50px;\n                    background: var(--chat-widget-compose-bar-voice-icon-bg);\n                    border: 2px solid var(--chat-widget-compose-bar-voice-icon-border);\n                    color: var(--chat-widget-compose-bar-voice-icon-color);\n                    border-radius: 62px;\n                    padding: 0;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    margin: 0 auto;\n                    position: absolute;\n                    top: -42px;\n                    right: 0;\n                    left: 0;\n                    cursor: pointer;  \n                    svg{\n                        path{\n                            fill: var(--sdk-global-white);\n                        }\n                        rect{\n                            fill: var(--sdk-global-white);\n                        }\n                    }             \n                }\n                .speak-info{\n                    font-weight: 400;\n                    font-size: 11px;\n                    line-height: 16px;\n                    color: var(--chat-widget-compose-bar-voice-speak-info-text);\n                    margin-top: 10px;\n                }\n            }\n            .compose-voice-text-recording{\n                @extend .compose-voice-text;\n                opacity: 1 !important;\n                -webkit-animation-name: zoomIn;\n                animation-name: zoomIn !important;\n                -webkit-animation-duration: 1s;\n                animation-duration: 1s;\n                -webkit-animation-fill-mode: both;\n                animation-fill-mode: both;\n                .voice-compose-btn-recording{\n                    @extend .voice-compose-btn;\n                    animation: recording 2s infinite ease-in-out;\n                    .speak-info{\n                        margin-top: 15px;\n                    }\n                }           \n                .cancel-sepak{\n                    background: transparent;\n                    border: 0;\n                    padding: 2px 8px;\n                    color: var(--sdk-global-theme-color);\n                    text-align: center;\n                    font-size: 11px;\n                    font-weight: 600;\n                    line-height: 16px;\n                    margin-top: 4px;\n                }     \n            }\n            .compose-voice-text-end{\n                @extend .compose-voice-text;\n                animation-name: bubbleAnim;\n                animation-duration: 0.5s;\n                animation-fill-mode: forwards;\n                opacity: 0;\n                opacity: 1 !important;\n                .voice-compose-btn-end{\n                    @extend .voice-compose-btn;\n                }  \n            }\n            .action-btn{\n                margin-top: 0;\n            }\n            .voice-btn{\n                margin-top: 0;\n            }\n        }\n        .action-btn{\n            width: 20px;\n            height: 20px;\n            border: 0;\n            padding: 0;\n            background: transparent;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-top: 12px;\n            margin-right: 8px;\n            flex-shrink: 0;\n            color: var(--chat-widget-compose-bar-text-area-color);\n            &.hamberger-menu{\n                svg{\n                    path{\n                        fill: var(--chat-widget-compose-bar-menu-icon-color);\n                    }\n                }\n            }\n            &.connect-to-agent{\n                svg{\n                    path{\n                        stroke: var(--chat-widget-compose-bar-other-icons);\n                        fill: none;\n                    }\n                }\n                &.disabled{\n                    opacity: 0.4;\n                    cursor: none;\n                    pointer-events: none;\n                }\n            }\n            svg{\n                path{\n                    fill: var(--chat-widget-compose-bar-other-icons);\n                }\n            }            \n        }\n        .compose-text-area{\n            position: relative;\n            width: 100%;\n            border-radius: 4px;\n            line-height: 1px;\n            transform-origin: right bottom;\n            transition: 0.2s all ease-in-out;\n            &.emoji-btn-true{\n                .typing-text-area{\n                    padding-right: 62px;\n                }\n            }\n            &.only-emoji-btn {\n                .emoji-btn {\n                    right: 12px;\n                }\n            }\n            .emoji-btn{\n                width: 20px;\n                height: 20px;\n                border: 0;\n                padding: 0;\n                background: transparent;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                position: absolute;\n                right: 38px;\n                top: 12px;\n                figure{\n                    line-height: 0;\n                }\n                svg{\n                    path{\n                        fill: var(--sdk-gloabl-text-color);\n                    }\n                }\n            }\n            .speaker-btn {\n                width: 20px;\n                height: 20px;\n                border: 0;\n                padding: 0;\n                background: transparent;\n                align-items: center;\n                justify-content: center;\n                position: absolute;\n                right: 12px;\n                top: 12px;\n            }\n            .speaker-btn-speak {\n                svg {\n                    path {\n                        fill: none;\n                        stroke: var(--chat-widget-compose-bar-other-icons);\n                    }\n                } \n                &.show {\n                    display: flex;\n                }\n                &.hide {\n                    display: none;\n                }\n            }\n            .speaker-btn-mute {\n                svg {\n                    path {\n                        fill: var(--chat-widget-compose-bar-other-icons);\n                    }\n                } \n                &.show {\n                    display: flex;\n                }\n                &.hide {\n                    display: none;\n                }\n            }\n            .typing-text-area{\n                width: 100%;\n                padding: 12px 35px 12px 12px;\n                resize: none;\n                background: var(--chat-widget-compose-bar-text-area-bg);\n                border: 1px solid var(--chat-widget-compose-bar-text-area-border);\n                border-radius: 4px;\n                height: 44px;\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 17px;                \n                color: var(--chat-widget-compose-bar-text-area-color);\n                // font-family: 'Inter';\n                &::placeholder{\n                    color: var(--chat-widget-compose-bar-text-area-placeholder-color);\n                }\n                &:focus{\n                    border: 0.5px solid var(--sdk-global-theme-color);\n                }\n                &:active{\n                    border: 0.5px solid var(--sdk-global-theme-color);\n                }\n                &:focus-visible{\n                    outline-color: var(--sdk-global-theme-color);\n                    outline-offset: 0px;\n                    outline-style: solid;\n                }\n            }\n        }\n        .compose-voice-text{\n            display: none;\n        }\n        .compose-voice-text-recording {\n            display: none;\n        }\n        .compose-voice-text-end {\n            display: none;\n        }\n        .key-board{\n            width: 20px;\n            height: 20px;\n            border: 0;\n            padding: 0;\n            background: transparent;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-top: 12px;\n            margin-left: 8px;\n            flex-shrink: 0;\n            svg{\n                path{\n                    fill: var(--chat-widget-compose-bar-other-icons);\n                }\n            } \n        }\n        .voice-btn{\n            width: 20px;\n            height: 20px;\n            border: 0;\n            padding: 0;\n            background: transparent;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin-top: 12px;\n            margin-left: 8px;\n            flex-shrink: 0;\n            svg{\n                path{\n                    fill: var(--chat-widget-compose-bar-other-icons);\n                }\n            } \n        }\n        .send-btn{\n            width: 41px;\n            height: 44px;\n            background: var(--sdk-global-theme-color);\n            border-radius: 4px;\n            padding: 0;\n            border: 0;\n            display: none;\n            align-items: center;\n            flex-shrink: 0;\n            justify-content: center;\n            cursor: pointer;\n            margin-left: 8px;\n            svg{\n                path{\n                    fill: var(--sdk-global-white);\n                }\n            }\n            &.show{\n                display: flex;\n            }\n            &.disabled {\n                background-color: #CDD5DF;\n                cursor: none;\n                pointer-events: none;\n            }\n        }\n    }\n    .emoji-picker-section{\n        height: 280px;\n        position: absolute;\n        top: -262px;\n        z-index: 1;\n        width: 360px;\n        right: 20px;\n        border-radius: 16px;\n        background: var(--sdk-global-white-bg);\n        box-shadow: 0px 32px 64px -12px rgba(16, 24, 40, 0.14);\n        &::before{\n            content: \"\";\n            position: absolute;\n            bottom: -8px;\n            right: 64px;\n            // border-color: var(--sdk-global-white) transparent transparent transparent;\n            // border-style: solid;\n            // border-width: 15px;\n            width: 16px;\n            height: 16px;\n            background: #fff;\n            transform: rotate(45deg);\n            background: var(--sdk-global-white-bg);\n            filter: drop-shadow(0px 24px 48px rgba(16, 24, 40, 0.18));\n        }\n        &.emoji-only::before {\n            right: 38px;\n        }\n        emoji-picker{\n            height: 100%;\n            width: 100%;     \n            padding: 10px;       \n        }\n    }\n}\n\n.disableComposeBar {\n    pointer-events: none;\n    opacity: 0.4;\n}\n\n\n// Attachment Wrapper\n\n.attachment-wrapper-data{\n    border-radius: 0px 0px 4px 4px;\n    .select-file-block{\n        .inputfile-btn{\n            flex: 0 0 calc((100% - 12px) / 2);\n            width: calc((100% - 12px) / 2);\n            min-width: 0;\n            border: 1px solid var(--sdk-global-white-bg);\n            padding: 12px 20px;\n            text-align: center;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 24px;\n            color: var(--button-text-color);\n            height: 44.72px;\n            gap: 8px;\n            svg{\n                path{\n                    fill: var(--button-text-color);\n                }\n            }\n            input{\n                position: absolute;\n                opacity: 0;\n                left: 0;\n                width: 100%;\n                height: 100%;\n                top: 0px;\n                font-size: 0px;\n                cursor: pointer;\n            }\n        }\n    }\n    &.hide-attachment {\n        display: none;\n    }\n}\n\n// Attached Items\n.uploaded-attachment-data{\n    background: var(--sdk-global-white-bg);\n    border-radius: 4px;\n    display: inline-block;\n    width: 100%;\n    overflow-y: auto;\n    max-height: 250px;\n    &:not(:empty){\n        padding: 8px 16px;\n    }\n    .uploaded-item{\n        display: flex;\n        align-items: center;\n        padding: 8px 0;\n        width: 100%;\n        word-break: break-word;\n        .img-block{\n            width: 56px;\n            height: 56px;\n            background: var(--sdk-gloabl-bg-secondary);\n            border-radius: 4px;\n            flex-shrink: 0;\n            margin-right: 8px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n        .content-data{\n            width: 100%;\n            h1{\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 17px;\n                color: var(--sdk-gloabl-text-color);\n                margin-bottom: 8px;\n            }\n            .progress-percentage{\n                height: 5px;\n                width: 100%;\n                background: var(--sdk-gloabl-bg-secondary);\n                border-radius: 4px;\n                margin: 8px 0;\n                div{\n                    height: 100%;\n                    background: var(--sdk-global-theme-color);\n                    border-radius: 4px;\n                    width: 70%;\n                }\n            }\n            .size-completion {\n                display: flex;\n                .file-size {\n                    padding-right: 3px;\n                }\n                p{\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 18px;\n                    color: var(--sdk-gloabl-text-color);\n                }\n            }\n            .upload-error-status {\n                display: flex;\n                align-items: center;\n                gap: 4px;\n                margin-top: 4px;\n                &.hide-error-status {\n                    display: none;\n                }\n\n                .upload-failed-text {\n                    font-size: 12px;\n                    line-height: 18px;\n                    color: #D92D20;\n                    font-weight: 500;\n                }\n                .info-icon {\n                    display: flex;\n                    align-items: center;\n                    cursor: help;\n                    position: relative;\n                    .error-tooltip {\n                        visibility: hidden;\n                        width: max-content;\n                        max-width: 250px;\n                        background-color: var(--sdk-global-white-bg);\n                        color: var(--sdk-gloabl-text-color);\n                        border-radius: 6px;\n                        padding: 8px 12px;\n                        position: absolute;\n                        z-index: 9;\n                        bottom: 150%;\n                        left: -8px;\n                        box-shadow: var(--form-temp-input-box-shadow);\n                        border: 1px solid var(--sdk-gloabl-border-color);\n                    \n                        font-size: 12px;\n                        line-height: 18px;\n                        font-weight: 400;\n                        white-space: normal;\n                        word-wrap: break-word;\n                        opacity: 0;\n                        transition: opacity 0.2s;\n                        \n                        &::after {\n                            content: \"\";\n                            position: absolute;\n                            top: 100%;\n                            left: 14px;\n                            margin-left: -5px;\n                            border-width: 5px;\n                            border-style: solid;\n                            border-color: var(--sdk-global-white-bg) transparent transparent transparent;\n                        }\n                    }\n\n                    &:hover .error-tooltip {\n                        visibility: visible;\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n        .delete-upload{\n            cursor: pointer;\n            line-height: normal;\n            margin-left: 8px;\n            padding: 0;\n            border: 0;\n            background: transparent;\n            figure{\n                line-height: 0;\n            }\n        }\n        &.upload-success{\n            .progress-percentage{\n                display: none;\n            }\n            .size-completion{\n                .file-size{\n                    display: none;\n                }\n                p{\n                    color: #008000;\n                    font-weight: 500;\n                }\n            }\n        }\n    }\n}\n\n// END\n\n\n// Typing Indicator\n.typing-indicator-wraper{\n    position: absolute;\n    top: -28px;\n    left: 0;\n    width: auto;\n    min-width: 116px;\n    display: none;\n    align-items: center;\n    gap: 20px;\n    padding: 4px 0 4px 16px;\n    border-radius: 0px 6px 6px 0px;\n    background: var(--sdk-global-white-bg);\n    z-index: 9;\n    p{\n        color: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 20px;\n        margin-right: 6px;\n    }\n    .dot-flashing {\n        position: relative;\n        width: 8px;\n        height: 8px;\n        border-radius: 5px;\n        background-color: var(--sdk-global-theme-color);\n        color: var(--sdk-global-theme-color);\n        animation: dot-flashing 1s infinite linear alternate;\n        animation-delay: 0.5s;\n        &::before{\n            content: \"\";\n            display: inline-block;\n            position: absolute;\n            top: 0;\n            left: -15px;\n            width: 8px;\n            height: 8px;\n            border-radius: 5px;\n            background-color: var(--sdk-global-theme-color);\n            color: var(--sdk-global-theme-color);\n            animation: dot-flashing 1s infinite alternate;\n            animation-delay: 0s;\n        }\n        &::after{\n            content: \"\";\n            display: inline-block;\n            position: absolute;\n            top: 0;\n            left: 15px;\n            width: 8px;\n            height: 8px;\n            border-radius: 5px;\n            background-color: var(--sdk-global-theme-color);\n            color: var(--sdk-global-theme-color);\n            animation: dot-flashing 1s infinite alternate;\n            animation-delay: 1s;\n        }\n    }\n}\n\n// Powered By\n.powerdby-info {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 6px 16px;\n    background: var(--sdk-global-white-bg);\n    height: 18px;\n    p {\n        font-weight: 500;\n        font-size: 10px;\n        line-height: 12px;\n        color: var(--welecome-footer-text-color);\n        margin-right: 5px;\n        flex-shrink: 0;\n    }\n    figure {\n        padding: 0 0 3px 0;\n    }\n    &.powerdby-hide {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
